import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Categoria } from "@sharedV11/classes/categoria/categoria";
import { MotivosDevolucion } from "@sharedV11/classes/motivos-devolucion/motivosDevolucion";
import { IdiomaGR } from "@sharedV11/classes/tarifaResponse/idiomaGR";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { EditCategoriasService } from "@sharedV11/services/components/Categorias/edit-categorias.service";
import { EditMotivoDevolucionService } from "@sharedV11/services/components/edit-motivos-devolucion/edit-motivo-devolucion.service";
import { GlobalServicCentros } from "@sharedV11/services/global/global.service centros";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { DualListComponent } from "angular-dual-listbox";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-edit-motivos-devolucion",
  templateUrl: "./edit-motivos-devolucion.component.html",
  styleUrls: ["./edit-motivos-devolucion.component.scss"],
})
export class EditMotivosDevolucionComponent implements OnInit {

  loading = true;
  private ngUnsubscribe = new Subject();

  @Input() pkId: string;
  @Input() mode: string;
  @Input() modificar: boolean;

  translation: any;

  editRegistroForm: FormGroup;

  editorListaIdiomas: Array<IdiomaGR> = [];
  idiomasApp: Array<IdiomaGR>;
  tiposIdiomasAPI: any;
  tiposIdiomas: any;
  //centros
  centrosSinAsignar = [];
  centrosAsignados = [];
  tipoCentros: any[] = [];
  //centros
  format = {
    add: "Añadir",
    remove: "Borrar",
    all: "Todos",
    none: "Ninguno",
    direction: DualListComponent.LTR,
    draggable: true,
    locale: "es",
  };

  // Categoria: Categoria;
  MotivoDevolucion: MotivosDevolucion;

  constructor(
    // private editCategoriaService: EditCategoriasService,
    private editMotivoDevolucionaService: EditMotivoDevolucionService,
    private fb: FormBuilder,
    private translator: Translator,
    private panelService: PanelService,
    private snackvar_service: SnackbarInfoService,
    private httpErrorService: HttpErrorsService,
    private gsCentros: GlobalServicCentros,
    private servicioAPI: ConectarApiService,
  ) {}

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit(): void {
    // this.loadCentros();
    this.initializeTranslate();
    this.initializeFormWithoutData();
    this.cargarDatosAsync();
    // this.getIdiomas();
    // this.manageForm(this.pkId, this.mode);
  }

  async loadCentros() {
    await this.gsCentros.getCentros();
  }

  async cargarDatosAsync(): Promise<boolean> {
    //Cargamos Datos
    let resultado: boolean = false;
    var tiposUsuariotmp;
    //centros en cargar datos
    await this.servicioAPI.getIdiomasAsync(null, null, "1").then(
      (data) => {
        this.tiposIdiomasAPI = data;
        if (this.tiposIdiomasAPI.DatosResult != null) {
          this.tiposIdiomas = this.tiposIdiomasAPI.DatosResult.ListaIdiomas;
          this.editorListaIdiomas = this.tiposIdiomas;
          this.addIdiomasControlInForm(this.tiposIdiomas);
          //
          //this.tiposGruposConMotivo = this.tiposGrupos.filter(x => x.ConMotivo.trim().toLowerCase() == 'true' || x.ConMotivo.trim().toLowerCase() == '1')
          //tiposUsuariotmp = this.tiposGrupos;
        } else {
          // this.alertaServicio.error(
          //   this.tiposIdiomasAPI.Mensajes[0].DescripcionMensaje
          // );
          // resultado = false;
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
        resultado = false;
      }
    );
    
    this.loadCentros();

    this.manageForm(this.pkId, this.mode);

    return resultado;
  }

  addIdiomasControlInForm(tiposIdiomas) {
    console.log('addIdiomasControlInForm',tiposIdiomas);
    tiposIdiomas.map((idioma) => {
      this.editRegistroForm.addControl(
        "Nombre-" + idioma.CodIdioma,
        new FormControl("")
      );
      this.editRegistroForm.addControl(
        "Descripcion-" + idioma.CodIdioma,
        new FormControl("")
      );
      //this.editorRegistroForm.addControl("Descripcion1-" + idioma.CodIdioma, new FormControl(""))
      //this.editorRegistroForm.addControl("Descripcion2-" + idioma.CodIdioma, new FormControl(""))
      this.editRegistroForm.addControl(
        "Url-" + idioma.CodIdioma,
        new FormControl("")
      );
    });
  }

  getIdiomas(idiomasgrupo?, mode?) {

    // this.servicioAPI.getIdiomasAsync(null, null, "1").then(
    //   (data) => {
    //     this.tiposIdiomasAPI = data;
    //     if (this.tiposIdiomasAPI.DatosResult != null) {
    //       this.tiposIdiomas = this.tiposIdiomasAPI.DatosResult.ListaIdiomas;
    //       this.editorListaIdiomas = this.tiposIdiomas;
    //       this.addIdiomasControlInForm(this.tiposIdiomas);
    //       //
    //       //this.tiposGruposConMotivo = this.tiposGrupos.filter(x => x.ConMotivo.trim().toLowerCase() == 'true' || x.ConMotivo.trim().toLowerCase() == '1')
    //       //tiposUsuariotmp = this.tiposGrupos;
    //     } else {
    //       // this.alertaServicio.error(
    //       //   this.tiposIdiomasAPI.Mensajes[0].DescripcionMensaje
    //       // );
    //       // resultado = false;
    //     }
    //   },
    //   (error) => {
    //     this.httpErrorService.identificarErrores(error);
    //     // resultado = false;
    //   }
    // );

		this.servicioAPI.getIdiomas().subscribe(
			(losidiomas) => {
        this.tiposIdiomasAPI = losidiomas;
				// this.idiomasApp = losidiomas.DatosResult.ListaIdiomas;
				this.editorListaIdiomas = losidiomas.DatosResult.ListaIdiomas;
				if (mode) {
					losidiomas.DatosResult.ListaIdiomas.map((idioma) => {
						idiomasgrupo.forEach((ig) => {
							if (ig.CodIdioma == idioma.CodIdioma) {
								let elidioma: IdiomaGR = new IdiomaGR();
								elidioma.CodIdioma = ig.CodIdioma;
								elidioma.Nombre = ig.Nombre;
								elidioma.Descripcion = ig.Descripcion;
								// this.editorListaIdiomas.push(elidioma);
								this.idiomasApp.push(elidioma);
							}
						});
					});
          
          //TODO registro
					//this.tiposesiondata = this.editTiposSesionForm.value;
					this.valuedChanged();
				}
        console.log('tiposidiomas',this.tiposIdiomasAPI);
        // nuevo
        if (this.tiposIdiomasAPI.DatosResult != null) {
          this.tiposIdiomas = this.tiposIdiomasAPI.DatosResult.ListaIdiomas;
          this.editorListaIdiomas = this.tiposIdiomas;
          this.addIdiomasControlInForm(this.tiposIdiomas);
        }

			},
			(error) => {
				this.httpErrorService.identificarErrores(error);
			}
		);
	}

  async initializeTranslate() {
    this.translation = this.translator.GetTranslations();
    this.format = {
      add: this.translation.Anadir,
      remove: this.translation.Borrar,
      all: this.translation.Todos,
      none: this.translation.Ninguno,
      direction: DualListComponent.LTR,
      draggable: true,
      locale: "es",
    };
  }

  initializeFormWithoutData() {
    this.editRegistroForm = this.fb.group({
      pkId: [""],
      NombreMotivo: ["", Validators.required],
      Seleccionable: [false],
      Idiomas: [""],
      CentrosIds: [""],
    });
  }
  manageForm(pkId, mode) {
    if (mode == "I") {
      this.MotivoDevolucion = this.editRegistroForm.value;
      this.centrosSinAsignar = this.gsCentros.filtrarTiposCentros();
      this.loading = false;
      this.valuedChanged();
    }
    if (pkId != null) {
      this.findMotivoDevolucion(pkId);
    }
  }

  findMotivoDevolucion(pkId) {
    this.editMotivoDevolucionaService
      .findMotivoDevolucionByPkId(pkId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          let motivoDevolucion: MotivosDevolucion = response["DatosResult"]["customanMotivosDevoluciones"][0];

          if (motivoDevolucion != null) {
            // motivoDevolucion.Idioma = this.obtenerIdiomasConOrden(motivoDevolucion);
            this.changeValueForm(motivoDevolucion);
            this.MotivoDevolucion = this.editRegistroForm.value;
            this.MotivoDevolucion.CentrosIds = motivoDevolucion.CentrosIds;
            this.centrosSinAsignar = this.gsCentros.filtrarTiposCentros();
            this.centrosAsignados = this.gsCentros.daTiposCentros(
              this.MotivoDevolucion
            );
            // this.editorListaIdiomas = motivoDevolucion.Idiomas
            this.idiomasApp = motivoDevolucion.Idiomas
            this.valuedChanged();
            this.loading = false;
          }
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  changeValueForm(motivoDevolucion: MotivosDevolucion) {
    this.editRegistroForm.get("pkId").setValue(motivoDevolucion.pkId);
    this.editRegistroForm.get("NombreMotivo").setValue(motivoDevolucion.NombreMotivo);
    this.editRegistroForm.get("Seleccionable").setValue(motivoDevolucion.Seleccionable == "1");
    this.editRegistroForm.get("Idiomas").setValue(motivoDevolucion.Idioma);
    this.editRegistroForm.get("CentrosIds").setValue(motivoDevolucion.CentrosIds);

    // if (!motivoDevolucion.Idiomas) {
    //   this.editorListaIdiomas.map((idioma) => {
    //     let idiomaToData: any = {};

    //     this.f["Nombre-" + idioma.CodIdioma].setValue(
    //       motivoDevolucion["Nombre-" + idioma.CodIdioma]
    //     );
    //     this.f["Descripcion-" + idioma.CodIdioma].setValue(
    //       motivoDevolucion["Descripcion-" + idioma.CodIdioma]
    //     );
    //     //this.f["Descripcion1-" + idioma.CodIdioma].setValue(motivoDevolucion["Descripcion1-" + idioma.CodIdioma])
    //     //this.f["Descripcion2-" + idioma.CodIdioma].setValue(motivoDevolucion["Descripcion2-" + idioma.CodIdioma])
    //     this.f["Url-" + idioma.CodIdioma].setValue(
    //       motivoDevolucion["Url-" + idioma.CodIdioma]
    //     );
    //   });
    // } else {
      console.log('changeValueForm',motivoDevolucion.Idiomas);
      motivoDevolucion.Idiomas.map((idioma) => {
        this.f["Nombre-" + idioma.CodIdioma].setValue(idioma.Nombre);
        this.f["Descripcion-" + idioma.CodIdioma].setValue(idioma.Descripcion);
        //this.f["Descripcion1-" + idioma.CodIdioma].setValue(idioma.Descripcion1)
        //this.f["Descripcion2-" + idioma.CodIdioma].setValue(idioma.Descripcion2)
        this.f["Url-" + idioma.CodIdioma].setValue(idioma.URL);
      });
    // }

  }

  valuedChanged() {
    this.editRegistroForm.valueChanges.subscribe((value) => {
      if (this.MotivoDevolucion != null) {
        this.panelService.setDiscardChanges(false);
        if (JSON.stringify(value) === JSON.stringify(this.MotivoDevolucion)) {
          this.panelService.setDiscardChanges(true);
        }
      }
    });
  }
  submit() {
    //this.flagInput=!this.flagInput
    this.editRegistroForm.markAllAsTouched();
    let MotivosDevolucion: MotivosDevolucion = this.editRegistroForm.value;
    if (this.editRegistroForm.valid) {
      this.manageApi(MotivosDevolucion, this.mode);
    }
  }

  destroy() {
    this.panelService.setDiscardChanges(true);
    this.panelService.setClosePanel(null);
  }

  save() {
    this.loading = false;
    this.panelService.setDiscardChanges(true);

    this.panelService.setSavePanel(null);
  }
  discard() {
    this.changeValueForm(this.MotivoDevolucion);
  }

  obtenerIdiomasConOrden(Idiomas): string {
      let respuesta: string = '';
      let elemento: string;
      let count = 0;
      if (Idiomas) {
  
        Idiomas.forEach(idioma => {
          elemento = idioma.CodIdioma + ',';
          respuesta = respuesta + elemento;
          count++;
        });
      }
      return respuesta.substring(0, respuesta.length - 1);
    }

  get f() {
    return this.editRegistroForm.controls;
  }

  manageApi(motivoDevolucion: MotivosDevolucion, mode) {
    motivoDevolucion.CentrosIds = this.gsCentros.obtenercentrosAsociadosconOrden(
      this.centrosAsignados
    );
    motivoDevolucion.Idioma = this.obtenerIdiomasConOrden(
      this.idiomasApp
    );

    this.editorListaIdiomas.map((idioma) => {
      idioma.Nombre = this.f["Nombre-" + idioma.CodIdioma].value;
      idioma.Descripcion = this.f["Descripcion-" + idioma.CodIdioma].value;
      //idioma.Descripcion1 = this.f["Descripcion1-" + idioma.CodIdioma].value
      //idioma.Descripcion2 = this.f["Descripcion2-" + idioma.CodIdioma].value
      idioma.URL = this.f["Url-" + idioma.CodIdioma].value;
    });
    motivoDevolucion.Idiomas = this.editorListaIdiomas;
    motivoDevolucion.Seleccionable = this.f["Seleccionable"].value ? "1" : "0";   

    this.loading = true;
    switch (mode) {
      case "I":
        //insert
        motivoDevolucion.pkId = "0";
        this.InsMotivoDevolucion(motivoDevolucion);
        break;
      case "U":
        //update
        this.UpdMotivoDevolucion(motivoDevolucion);

        break;
      case "D":
        //duplicate
        motivoDevolucion.pkId = "0";
        this.InsMotivoDevolucion(motivoDevolucion);

        break;

      default:
        break;
    }
  }
  UpdMotivoDevolucion(motivoDevolucion) {
    this.editMotivoDevolucionaService
      .updMotivoDevolucion(motivoDevolucion, "U")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          this.nextWindow(response);
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }
  InsMotivoDevolucion(motivoDevolucion) {
    this.editMotivoDevolucionaService
      .insMotivoDevolucion(motivoDevolucion, "I")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          this.nextWindow(response);
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }
  nextWindow(response: any) {
    const err = this.existErrors();
    if (!this.existErrors()) {
      this.save();
      this.destroy();
      if (response.Mensajes.length > 0) {
        response.Mensajes.forEach((element) => {
          this.snackvar_service.openSnackBar(
            element.DescripcionMensaje,
            "",
            "red-snackbar",
            element.CodigoMensaje
          );
        });
      } else {
        this.snackvar_service.openSnackBar(
          this.translation["MensajeSuccessSnackBar"],
          "",
          "green-snackbar"
        );
      }
    }
  }
  existErrors() {
    return this.editRegistroForm.get("pkId").errors ||
      this.editRegistroForm.get("NombreMotivo").errors
      ? true
      : false;
  }
  getErrorMessage(field: string) {
    let fc_pv = this.editRegistroForm.get(field);
    if (fc_pv) {
      if (fc_pv.errors) {
        if (fc_pv.errors.required) {
          return this.translation["CampoRequerido"];
        } else if (field === "Empleado") {
          if (fc_pv.hasError("pattern")) {
            return this.translation["SoloNumeros"];
          }
        } else if (field === "Nombre") {
          if (fc_pv.hasError("pattern")) {
            return this.translation["SoloLetras"];
          }
        }
      }
    }

    return "Error";
  }

  validateFields(field: string) {
    return this.isValidAnyField(field);
  }

  isValidAnyField(field: string) {
    let fc_pv = this.editRegistroForm.controls;
    return fc_pv[field].errors != null || fc_pv[field].invalid ? true : false;
  }

  cambiaDescripcion(evento, idioma) {
    this.editorListaIdiomas.find((x) => x.CodIdioma == idioma).Descripcion =
      evento;
    //
  }
  cambiaURL(evento, idioma) {
    this.editorListaIdiomas.find((x) => x.CodIdioma == idioma).URL = evento;
    //
  }
  cambiaNombre(evento, idioma) {
    this.editorListaIdiomas.find((x) => x.CodIdioma == idioma).Nombre = evento;
    //
  }


}
